import { createSelector } from 'reselect';
import _ from 'lodash';

const filesList = state => _.get(state, 'filesPage.list', []);

const formatSize = size => {
  if (!size) {
    return null;
  }
  const exp = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return {
    value: (size / Math.pow(1024, exp)).toFixed(2),
    unit: ['B', 'KB', 'MB', 'GB', 'TB'][exp],
    raw: size,
  };
};

const files = createSelector(filesList, filesList => {
  return filesList.map(f => {
    return {
      ...f,
      size: formatSize(f.size),
    };
  });
});

const activeFilesPath = createSelector(
  state => _.get(state, 'files.activeFilesPath', {}),
  activeFilesPath => activeFilesPath.activePath || '',
);

const isFileUploading = createSelector(
  state => _.get(state, 'files.upload', {}),
  upload => upload.isFetching || false,
);

export { activeFilesPath, files, isFileUploading };
